import { useQueries } from '@tanstack/react-query'
import useAssigneeList from 'hooks/useAssigneeList'
import {
  applyDefaultDateRange,
  mapBenefitFiltersToQuery,
} from 'modules/benefits/mappers/benefitFilters'
import { fetchApplication } from 'modules/benefits/methods'

export interface AssignmentQueue {
  assignee: string
  count: number
}

export function useBenefitQueuesQuery() {
  const finalAssigneeList = useAssigneeList({ isIncludeSpecialAssignee: true })

  const queries = useQueries({
    queries: finalAssigneeList.map((assignee) => ({
      queryKey: ['benefit-queue', assignee],
      queryFn: async () => {
        const result = await fetchApplication({
          page: 1,
          limit: 1,
          ...mapBenefitFiltersToQuery(applyDefaultDateRange({ assignee })),
        })
        return {
          assignee,
          count: result.total,
        }
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      gcTime: 10 * 60 * 1000, // 10 minutes
    })),
  })

  // Transform the results to match the expected format
  const data = queries
    .map((query) => query.data)
    .filter(Boolean) as AssignmentQueue[]
  const isLoading = queries.some((query) => query.isLoading)
  const error = queries.find((query) => query.error)?.error

  return {
    data,
    isLoading,
    error,
    queries, // Expose individual queries for more granular control if needed
  }
}
